 import * as types from '../mutation-types' 
 
export const state = { 
    nav: null,
    itemTableOrder: false,
    productionsOrder: false,
    settingActive: false,
    navLang: false,
    switchSlider : false,
}

export const getters = {
    nav: state => state.nav, 
    itemTableOrder: state => state.itemTableOrder,
    productionsOrder: state => state.productionsOrder,
    settingActive: state => state.settingActive,
    navLang : state => state.navLang,
    switchSlider: state => state.switchSlider
}

export const mutations = {
    [ types.NAV_MENU] (state, payload) {
        state.nav = payload
    },
    [ types.ITEM_ORDER_TABLE] (state, payload) {
        state.itemTableOrder = payload
    },
    [ types.PRODUCTIONS_ORDER] (state, payload) {
        state.productionsOrder = payload
    },
    [types.SETTING_ACTIVE] (state, payload) {
        state.settingActive = payload
    },
    [types.NAV_LANG_ACTIVE](state,payload){
        state.navLang = payload
    },
    [types.NAV_LANG_INACTIVE](state,payload){
        state.navLang = payload
    },
    [types.NAV_SWITCH_SLIDER](state,payload){
        state.switchSlider = payload
    }
} 
export const actions = {
    nav_menu ({ commit, getters }, payload) {
        commit(types.NAV_MENU, !getters.nav) 
    },
    collape_item_order ({ commit, getters }, payload) {
        commit(types.ITEM_ORDER_TABLE, !getters.itemTableOrder) 
    },
    collape_products_order ({ commit, getters }, payload) {
        commit(types.PRODUCTIONS_ORDER, !getters.productionsOrder)
    },
    collape_setting_active ({commit ,getters},payload) {
        commit(types.SETTING_ACTIVE, !getters.settingActive)
    },
    collapse_lang_active({commit,getters},payload){
        commit(types.NAV_LANG_ACTIVE,!getters.navLang)
    },
    collapse_lang_inactive({commit,getters},payload){
        commit(types.NAV_LANG_INACTIVE,payload)
    },
    collapse_nav_switch_slider({commit},payload){
        commit(types.NAV_SWITCH_SLIDER,payload);
    }
 
}
